// extracted by mini-css-extract-plugin
export var actionContainer = "index-module--actionContainer--kC+zS";
export var actionContent = "index-module--actionContent--VAYh+";
export var actionTitle = "index-module--actionTitle--53QSk";
export var actionsWrapper = "index-module--actionsWrapper--WPxKe";